// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'mic-solid';

export const Component = () => (
  <path d='M8.442 21.588h7.855c.335 0 .479.144.479.48 0 .334-.144.478-.48.478H8.443c-.335 0-.479-.144-.479-.479 0-.335.144-.479.48-.479Zm3.928-2.922c-1.198 0-2.251-.43-3.114-1.293-.862-.861-1.293-1.915-1.293-3.16V6.405c0-1.197.432-2.25 1.293-3.113A4.267 4.267 0 0 1 12.37 2c1.197 0 2.25.431 3.113 1.293a4.267 4.267 0 0 1 1.293 3.113v7.807c0 1.245-.431 2.299-1.293 3.16-.862.862-1.916 1.293-3.113 1.293Zm6.37-7.375v2.92c0 1.773-.624 3.305-1.869 4.55-1.245 1.246-2.73 1.869-4.501 1.869-1.772 0-3.257-.623-4.502-1.868C6.623 17.516 6 15.984 6 14.212V11.29c0-.336.144-.48.479-.48.335 0 .479.144.479.48v2.92c0 1.485.526 2.779 1.58 3.832s2.347 1.58 3.832 1.58c1.484 0 2.778-.526 3.83-1.58 1.054-1.054 1.581-2.347 1.581-3.831V11.29c0-.336.144-.48.48-.48.334 0 .478.144.478.48Z' />
);

export const viewBox = '0 0 25 25';
